export enum PreloadLevelType {
    none,
    amber,
    green
}